import React from 'react';
import { Text } from 'react-native';
import { useUnistyles } from 'react-native-unistyles';
import { looksLikeHtml } from '@/utils/serviceFlow';
import { serviceFlowStyles } from './serviceFlowStyles';

/**
 * Item notes inside the details card — web renders the stored TipTap HTML as
 * real markup (faithful bullets, alignment, and font sizes); plain-text notes
 * render as plain Text. Native uses the default variant (render-html).
 */
const ServiceFlowNotesBody = ({ text }) => {
    const { theme: { colors, fonts } } = useUnistyles();

    if (!looksLikeHtml(text)) {
        return <Text style={serviceFlowStyles.notesBody}>{text}</Text>;
    }

    return (
        <>
            <style>{`
                .sf-rich-notes { font-family: ${fonts.body}; font-size: 13px; line-height: 1.45; color: ${colors.onSurfaceVariant}; }
                /* Geist ships as named single-weight families — font-weight:bold
                   alone can't reach the semibold face, so swap the family. */
                .sf-rich-notes strong, .sf-rich-notes b { font-family: ${fonts.bold}; font-weight: normal; }
                .sf-rich-notes p { margin: 0 0 4px; }
                .sf-rich-notes p:empty { min-height: 1em; }
                .sf-rich-notes p:last-child { margin-bottom: 0; }
                .sf-rich-notes h1, .sf-rich-notes h2, .sf-rich-notes h3 { margin: 6px 0 2px; line-height: 1.3; color: ${colors.text}; font-family: ${fonts.bold}; font-weight: normal; }
                .sf-rich-notes h1 { font-size: 20px; }
                .sf-rich-notes h2 { font-size: 17px; }
                .sf-rich-notes h3 { font-size: 15px; }
                .sf-rich-notes ul, .sf-rich-notes ol { margin: 4px 0; padding-left: 20px; }
                .sf-rich-notes li { margin: 0; }
                .sf-rich-notes li p { margin: 0; }
                .sf-rich-notes blockquote { margin: 4px 0; padding-left: 10px; border-left: 2px solid ${colors.borderSubtle}; }
                .sf-rich-notes a { color: ${colors.primary}; }
            `}</style>
            <div className="sf-rich-notes" dangerouslySetInnerHTML={{ __html: text }} />
        </>
    );
};

export default ServiceFlowNotesBody;
